export { MilestoneAgentName, MilestoneStatus } from '@thoughtspot/blink-context';
export var AgentId;
(function (AgentId) {
    AgentId["ASK_QUESTIONS"] = "ask-questions";
    AgentId["BUILD_DASHBOARD"] = "build-dashboard";
    AgentId["EMBED_INSIGHTS"] = "embed-insights";
})(AgentId || (AgentId = {}));
export const ONBOARDING_KEY = {
    FUNCTION: 'function',
    INDUSTRY: 'industry',
};
export var FunctionId;
(function (FunctionId) {
    FunctionId["DATA_ANALYTICS"] = "data-analytics";
    FunctionId["PRODUCT_MANAGEMENT"] = "product-management";
    FunctionId["SALES_ACCOUNT_MANAGEMENT"] = "sales-account-management";
    FunctionId["MARKETING_GROWTH"] = "marketing-growth";
    FunctionId["FINANCE_ACCOUNTING"] = "finance-accounting";
    FunctionId["EXECUTIVE_LEADERSHIP"] = "executive-leadership";
    FunctionId["SOFTWARE_ENGINEERING"] = "software-engineering";
})(FunctionId || (FunctionId = {}));
export var IndustryId;
(function (IndustryId) {
    IndustryId["RETAIL_CPG"] = "retail-cpg";
    IndustryId["FINANCIAL_SERVICES"] = "financial-services";
    IndustryId["SOFTWARE_TECHNOLOGY"] = "software-technology";
    IndustryId["HEALTHCARE_LIFE_SCIENCES"] = "healthcare-life-sciences";
    IndustryId["MANUFACTURING_LOGISTICS"] = "manufacturing-logistics";
    IndustryId["MEDIA_TELECOM"] = "media-telecom";
    IndustryId["HOSPITALITY_TRANSPORTATION"] = "hospitality-transportation";
})(IndustryId || (IndustryId = {}));
export var UseCaseId;
(function (UseCaseId) {
    UseCaseId["WIN_RATE_DROP"] = "win-rate-drop";
    UseCaseId["DEALS_DRAGGING"] = "deals-dragging";
    UseCaseId["RENEWAL_RISK"] = "renewal-risk";
    UseCaseId["WIN_RATE_COLLAPSE"] = "win-rate-collapse";
    UseCaseId["PIPELINE_LEAK"] = "pipeline-leak";
    UseCaseId["QUOTA_AND_CHURN"] = "quota-and-churn";
    UseCaseId["CAC_SPIKE"] = "cac-spike";
    UseCaseId["CONVERSION_FALL"] = "conversion-fall";
    UseCaseId["CONVERSION_DROP"] = "conversion-drop";
    UseCaseId["CONVERSION_COLLAPSE"] = "conversion-collapse";
    UseCaseId["ROAS_EROSION"] = "roas-erosion";
    UseCaseId["CAC_BREAKDOWN"] = "cac-breakdown";
    UseCaseId["MQL_WASTE"] = "mql-waste";
    UseCaseId["REGIONAL_ROAS_GAP"] = "regional-roas-gap";
    UseCaseId["ADOPTION_DECLINE"] = "adoption-decline";
    UseCaseId["SLOW_TO_MARKET"] = "slow-to-market";
    UseCaseId["NPS_SLIPPAGE"] = "nps-slippage";
    UseCaseId["ADOPTION_ROOT_CAUSE"] = "adoption-root-cause";
    UseCaseId["DELIVERY_BOTTLENECK"] = "delivery-bottleneck";
    UseCaseId["NPS_ADOPTION_RISK"] = "nps-adoption-risk";
    UseCaseId["MARGIN_SQUEEZE"] = "margin-squeeze";
    UseCaseId["DSO_RISK"] = "dso-risk";
    UseCaseId["BUDGET_BLOWOUT"] = "budget-blowout";
    UseCaseId["BUDGET_OVERRUNS"] = "budget-overruns";
    UseCaseId["MARGIN_COMPRESSION"] = "margin-compression";
    UseCaseId["CASH_FLOW_RISK"] = "cash-flow-risk";
    UseCaseId["EBITDA_LEAK"] = "ebitda-leak";
    UseCaseId["EBITDA_EROSION"] = "ebitda-erosion";
    UseCaseId["REVENUE_VS_MARGIN"] = "revenue-vs-margin";
    UseCaseId["REVENUE_COST_SQUEEZE"] = "revenue-cost-squeeze";
    UseCaseId["REVENUE_COST_GAP"] = "revenue-cost-gap";
    UseCaseId["SATISFACTION_DIP"] = "satisfaction-dip";
    UseCaseId["MARKET_SHARE"] = "market-share";
    UseCaseId["PROFITABILITY_PARADOX"] = "profitability-paradox";
    UseCaseId["PROFITABILITY_GAP"] = "profitability-gap";
    UseCaseId["CLIENT_RETENTION_RISK"] = "client-retention-risk";
    UseCaseId["CUSTOMER_RETENTION_RISK"] = "customer-retention-risk";
    UseCaseId["OPEX_EFFICIENCY"] = "opex-efficiency";
    UseCaseId["OPEX_RETURNS"] = "opex-returns";
    UseCaseId["OPEX_AND_OUTCOMES"] = "opex-and-outcomes";
    UseCaseId["BUILD_FAILURES"] = "build-failures";
    UseCaseId["BUILD_RELIABILITY"] = "build-reliability";
    UseCaseId["BUILD_FAILURE_CAUSE"] = "build-failure-cause";
    UseCaseId["LEAD_TIME_RISING"] = "lead-time-rising";
    UseCaseId["INCIDENT_SURGE"] = "incident-surge";
    UseCaseId["INCIDENT_RATE"] = "incident-rate";
    UseCaseId["DELIVERY_SLOWDOWN"] = "delivery-slowdown";
    UseCaseId["DELIVERY_LAG"] = "delivery-lag";
    UseCaseId["STABILITY_RISK"] = "stability-risk";
    UseCaseId["PLATFORM_STABILITY"] = "platform-stability";
    UseCaseId["PIPELINE_FAILURES"] = "pipeline-failures";
    UseCaseId["PIPELINE_STALL"] = "pipeline-stall";
    UseCaseId["PIPELINE_DEAD_ENDS"] = "pipeline-dead-ends";
    UseCaseId["QUALITY_DROP"] = "quality-drop";
    UseCaseId["SLA_BREACHES"] = "sla-breaches";
    UseCaseId["SLA_MISSES"] = "sla-misses";
    UseCaseId["FAILURE_ROOT_CAUSE"] = "failure-root-cause";
    UseCaseId["FAILURE_ANALYSIS"] = "failure-analysis";
    UseCaseId["LATENCY_AND_QUALITY"] = "latency-and-quality";
    UseCaseId["LATENCY_QUALITY_GAP"] = "latency-quality-gap";
    UseCaseId["CAPACITY_RISK"] = "capacity-risk";
    UseCaseId["CONTRACT_WIN_RATE"] = "contract-win-rate";
    UseCaseId["LONG_SALES_CYCLES"] = "long-sales-cycles";
    UseCaseId["LONG_CLOSE_CYCLES"] = "long-close-cycles";
    UseCaseId["WIN_RATE_EROSION"] = "win-rate-erosion";
    UseCaseId["QUOTA_AND_RETENTION"] = "quota-and-retention";
    UseCaseId["PATIENT_CAC_RISING"] = "patient-cac-rising";
    UseCaseId["CAC_BY_CHANNEL"] = "cac-by-channel";
    UseCaseId["MQL_TO_PATIENT_GAP"] = "mql-to-patient-gap";
    UseCaseId["REGIONAL_REACH"] = "regional-reach";
    UseCaseId["ADOPTION_BY_SERVICE"] = "adoption-by-service";
    UseCaseId["SLOW_RELEASES"] = "slow-releases";
    UseCaseId["SLOW_DEPLOYMENTS"] = "slow-deployments";
    UseCaseId["SLOW_FEATURES"] = "slow-features";
    UseCaseId["SLOW_TO_SHIP"] = "slow-to-ship";
    UseCaseId["PATIENT_NPS_GAP"] = "patient-nps-gap";
    UseCaseId["ADOPTION_AND_CARE_GAP"] = "adoption-and-care-gap";
    UseCaseId["ADOPTION_GAP"] = "adoption-gap";
    UseCaseId["ADOPTION_COLLAPSE"] = "adoption-collapse";
    UseCaseId["RELEASE_LAG_RISK"] = "release-lag-risk";
    UseCaseId["RELEASE_LAG"] = "release-lag";
    UseCaseId["RELEASE_BOTTLENECK"] = "release-bottleneck";
    UseCaseId["NPS_AND_ADOPTION"] = "nps-and-adoption";
    UseCaseId["COLLECTIONS_RISK"] = "collections-risk";
    UseCaseId["AR_COLLECTIONS"] = "ar-collections";
    UseCaseId["AR_COLLECTIONS_RISK"] = "ar-collections-risk";
    UseCaseId["PATIENT_SATISFACTION"] = "patient-satisfaction";
    UseCaseId["CUSTOMER_SATISFACTION"] = "customer-satisfaction";
    UseCaseId["CUSTOMER_NPS_DROP"] = "customer-nps-drop";
    UseCaseId["MARGIN_PARADOX"] = "margin-paradox";
    UseCaseId["PATIENT_EXPERIENCE_RISK"] = "patient-experience-risk";
    UseCaseId["CLINICAL_SYSTEM_RISK"] = "clinical-system-risk";
    UseCaseId["DATA_QUALITY_RISK"] = "data-quality-risk";
    UseCaseId["DATA_QUALITY"] = "data-quality";
    UseCaseId["DATA_QUALITY_DROP"] = "data-quality-drop";
    UseCaseId["VOLUME_VS_THROUGHPUT"] = "volume-vs-throughput";
    UseCaseId["BOOKING_WIN_RATE"] = "booking-win-rate";
    UseCaseId["BOOKING_CONVERSION"] = "booking-conversion";
    UseCaseId["RENEWAL_EROSION"] = "renewal-erosion";
    UseCaseId["GUEST_CAC_RISING"] = "guest-cac-rising";
    UseCaseId["ROAS_BY_REGION"] = "roas-by-region";
    UseCaseId["CAC_VS_DIRECT"] = "cac-vs-direct";
    UseCaseId["GUEST_ADOPTION"] = "guest-adoption";
    UseCaseId["GUEST_NPS_GAP"] = "guest-nps-gap";
    UseCaseId["REVPAR_VS_COSTS"] = "revpar-vs-costs";
    UseCaseId["GUEST_SATISFACTION"] = "guest-satisfaction";
    UseCaseId["GUEST_EXPERIENCE_RISK"] = "guest-experience-risk";
    UseCaseId["DEPLOYMENT_LAG"] = "deployment-lag";
    UseCaseId["RFQ_CYCLE_LENGTH"] = "rfq-cycle-length";
    UseCaseId["LEAD_CAC_RISING"] = "lead-cac-rising";
    UseCaseId["MQL_CONVERSION"] = "mql-conversion";
    UseCaseId["TRADE_SHOW_ROAS"] = "trade-show-roas";
    UseCaseId["MQL_QUALITY_GAP"] = "mql-quality-gap";
    UseCaseId["SUBSCRIBER_CAC"] = "subscriber-cac";
    UseCaseId["SUBSCRIBER_ADOPTION"] = "subscriber-adoption";
    UseCaseId["SUBSCRIBER_NPS"] = "subscriber-nps";
    UseCaseId["ARPU_VS_COSTS"] = "arpu-vs-costs";
    UseCaseId["SUBSCRIBER_SATISFACTION"] = "subscriber-satisfaction";
    UseCaseId["SUBSCRIBER_RETENTION_RISK"] = "subscriber-retention-risk";
    UseCaseId["SHOPPER_CAC"] = "shopper-cac";
    UseCaseId["SHOPPER_ADOPTION"] = "shopper-adoption";
    UseCaseId["SHOPPER_NPS"] = "shopper-nps";
    UseCaseId["SHOPPER_SATISFACTION"] = "shopper-satisfaction";
    UseCaseId["SHOPPER_RETENTION_RISK"] = "shopper-retention-risk";
    UseCaseId["CAC_PAYBACK_DRAG"] = "cac-payback-drag";
    UseCaseId["CAC_RISING"] = "cac-rising";
    UseCaseId["MQL_TO_SQL_GAP"] = "mql-to-sql-gap";
    UseCaseId["REGIONAL_PIPELINE_GAP"] = "regional-pipeline-gap";
    UseCaseId["FEATURE_ADOPTION"] = "feature-adoption";
    UseCaseId["PLG_ADOPTION_GAP"] = "plg-adoption-gap";
    UseCaseId["ARR_VS_MARGIN"] = "arr-vs-margin";
    UseCaseId["GROWTH_MARGIN_TRADE"] = "growth-margin-trade";
    UseCaseId["DORA_METRIC_GAP"] = "dora-metric-gap";
})(UseCaseId || (UseCaseId = {}));
//# sourceMappingURL=types.js.map